let old_blogs = [
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/connetix-le-oynanabilecek-5-kutu-oyunu-fikri",
    title: "Connetix’le Oynanabilecek 5 Kutu Oyunu Fikri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_794.png?v=1743674593",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/news/connetix-rainbow-transport-set-ile-tekerlekli-yaratici-tasarimlar",
    title:
      "Connetix Rainbow Transport Set ile “Tekerlekli” Yaratıcı Tasarımlar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_796.png?v=1743757606",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/petit-collage-kutulu-oyun-setleri-hayal-gucune-tatli-bir-yolculuk",
    title: "Petit Collage Kutulu Oyun Setleri: Hayal Gücüne Tatlı Bir Yolculuk",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20620-min.png?v=1739023860",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/okul/okula-donus-ihtiyaclari",
    title: "Okula Dönüş İhtiyaçları",
    cat: "OKUL",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20601_35a65f66-578b-42f8-b2a8-fc1d7228b3a5.png?v=1739023861",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/uno-nasil-oynanir",
    title: "UNO Nasıl Oynanır?",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20592_149951e2-cc07-4984-8c40-fc633662cab2.png?v=1739023865",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/okul/okul-gunleri-icin-alti-basit-sac-stil",
    title: "Okul Günleri İçin Altı Basit Saç Stil",
    cat: "OKUL, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20590_b01690ec-242b-4936-8abe-8cf2f37d83ea.png?v=1739023864",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/anneanne-babaanne-evinde-birakabileceginiz-kullanisli-urunler",
    title: "Anneanne/Babaanne Evinde Bırakabileceğiniz Kullanışlı Ürünler",
    cat: "EV",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20582.png?v=1739023865",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/cocuklar-icin-kaykay-secimi",
    title: "Çocuklar İçin Kaykay Seçimi",
    cat: "AKTİVİTE, OYUN, SPOR",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20580.png?v=1739023865",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/havuz-deniz-cantaniz-icin-tum-ihtiyaclariniz-petit-collective-de",
    title: "Havuz/Deniz Çantanız İçin Tüm İhtiyaçlarınız Petit Collective’de",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20578.png?v=1739023868",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/cocuklar-icin-suda-guvenlik-onerileri",
    title: "Çocuklar İçin Suda Güvenlik Önerileri",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20574_a5625b5d-70c6-44c2-b75c-6792932ae95d.png?v=1739023869",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/yaz-tatili-icin-kitap-onerileri",
    title: "Yaz Tatili İçin Kitap Önerileri",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20572_20_1_040b0bcd-4967-40e9-ad56-6579eea82838.png?v=1743667333",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/yaz-tatilinde-cocuklar-icin-ihtiyac-listesi",
    title: "Yaz Tatilinde Çocuklar İçin İhtiyaç Listesi",
    cat: "SEYAHAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20283.jpg?v=1739023869",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklariniza-ogretebileceginiz-5-acil-durum-dersi",
    title: "Çocuklarınıza Öğretebileceğiniz 5 Acil Durum Dersi",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20419_c457b8b3-4462-47f8-88f2-210323c0d44c.jpg?v=1739023872",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/denge-bisikletinin-faydalari",
    title: "Denge Bisikletinin Faydaları",
    cat: "GELİŞİM, OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/denge_20bisikleti_20kapak_0bba6796-8848-4017-b5ee-794f60c1706b.png?v=1739023873",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/zamanda-yolculuk-cocuklar-icin-zaman-kapsulu",
    title: "Zamanda Yolculuk: Çocuklar İçin Zaman Kapsülü",
    cat: "AKTİVİTE",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20568_20_1_1dce00e5-fc60-4dda-b881-4ff2c8e823dc.png?v=1739023873",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/kagittan-el-isi-kelebekler",
    title: "Kağıttan El İşi Kelebekler",
    cat: "AKTİVİTE",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20570_85929593-fe22-43ca-ad0e-f55e9c489638.png?v=1739023874",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/icerigi-guvenilir-eglenceli-ve-egitici-cizgi-filmler-ve-programlar",
    title:
      "İçeriği Güvenilir, Eğlenceli ve Eğitici Çizgi Filmler ve Programlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20572_c7d9e9c5-9a56-4eb9-8b74-676820a0d17b.png?v=1739023876",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/ilkbahar-yapraklarindan-aktivite-onerileri",
    title: "İlkbahar Yapraklarından Aktivite Önerileri",
    cat: "AKTİVİTE",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20568.png?v=1739023877",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/kucuk-gezginler-icin-tatil-bavulu-rehberi",
    title: "Küçük Gezginler İçin Tatil Bavulu Rehberi",
    cat: "SEYAHAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20566.jpg?v=1739023877",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/cocuklari-cizim-ve-boyama-yapmaya-tesvik-eden-urunler",
    title: "Çocukları Çizim ve Boyama Yapmaya Teşvik Eden Ürünler",
    cat: "AKTİVİTE, KİTAP, OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20564.jpg?v=1739023881",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/eksantrik-ve-essiz-klasiklerin-yaraticisi-roald-dahl-i-taniyalim",
    title: "Eksantrik ve Eşsiz Klasiklerin Yaratıcısı, Roald Dahl’ı Tanıyalım",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20560_356f7ccf-a4ba-439b-9d52-3ed80bfbc322.jpg?v=1739023880",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/ek-gidaya-gecis-surecine-eslik-eden-urunler",
    title: "Ek Gıdaya Geçiş Sürecine Eşlik Eden Ürünler",
    cat: "BAKIM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20558_08ad1ad7-0d38-4549-b9e4-8937e70b3210.jpg?v=1739023880",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/kendin-yap-hediyeler-icin-aktivite-kitleri",
    title: "Kendin Yap Hediyeler İçin Aktivite Kitleri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20556_d993f158-dd59-4b2c-88d0-2221dacd9740.png?v=1739023880",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/ebeveynlerin-de-severek-oynayacagi-oyunlar",
    title: "Ebeveynlerin de Severek Oynayacağı Oyunlar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20552_0593f8dc-63d9-40ed-9db1-7e60b63ddbb0.png?v=1739023882",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/tatil-donemine-eslik-edecek-oyuncak-ve-kitaplar",
    title: "Tatil Dönemine Eşlik Edecek Oyuncak ve Kitaplar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20550_e0cff529-e67e-434c-abfd-859c0b5286ed.png?v=1739023883",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/somestir-tatili-icin-etkinlik-onerileri",
    title: "Sömestir Tatili İçin Etkinlik Önerileri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20432.jpg?v=1739023915",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/yilbasi-eglencesi-icin-kutu-oyunu-onerileri",
    title: "Yılbaşı Eğlencesi İçin Kutu Oyunu Önerileri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20544_09fdc839-3cdd-4674-bc4f-653372b54aee.png?v=1739023884",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/bir-cocuktan-digerine-aktarilacak-favori-oyuncaklar",
    title: "Bir Çocuktan Diğerine Aktarılacak Favori Oyuncaklar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20533_166def9f-6df4-4d87-8430-9eb42dc423a2.jpg?v=1739023886",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-eylul-2023",
    title: "ÇOCUKLARLA ETKİNLİK REHBERİ: EYLÜL 2023",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20529_1_887120b2-125f-4a49-8340-d5a63a0dffb8.png?v=1739023886",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/zamansiz-ve-egitici-cekcek-oyuncaklar",
    title: "Zamansız ve Eğitici Çekçek Oyuncaklar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20515_d45feed6-6480-49a3-8e53-80a3e9361a58.png?v=1739023891",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/parti/deniz-kizi-temasiyla-kutlama-zamani",
    title: "Deniz Kızı Temasıyla Kutlama Zamanı!",
    cat: "PARTİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20513_cdee6794-4abd-4f5e-89e5-f36052af02cf.png?v=1739023891",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/bebekler-ve-kucuk-cocuklar-icin-duyusal-oyun-fikirleri",
    title: "Bebekler ve Küçük Çocuklar İçin Duyusal Oyun Fikirleri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20511_532c769c-0c1e-4811-9baf-ceef484364ba.png?v=1739023892",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/ilhamini-yaz-mevsiminden-alan-isimler",
    title: "İlhamını Yaz Mevsiminden Alan İsimler",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20507_2701c3ed-4a35-4ef8-93f9-5febf603ac7c.png?v=1739023893",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklugunuzun-filmlerini-cocuklarinizla-yeniden-kesfedin",
    title: "Çocukluğunuzun Filmlerini, Çocuklarınızla Yeniden Keşfedin!",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20501_702d822b-0491-4672-80f5-581b41422a0d.png?v=1739023894",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/spor/cocuklarin-yaz-aylarinda-tanisabilecekleri-sporlar",
    title: "Çocukların Yaz Aylarında Tanışabilecekleri Sporlar",
    cat: "SPOR",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20499_14787fe2-ac11-4b8a-b0df-fcf23b17c24a.jpg?v=1739023895",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/cocuklar-icin-bisiklet-secimi",
    title: "Çocuklar İçin Bisiklet Seçimi",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20493_8d044073-3a71-4730-b476-df59d0d11ce6.png?v=1739023895",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/bisiklet-surmenin-faydalari",
    title: "Bisiklet Sürmenin Faydaları",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20487_5e5526aa-8f7d-4f56-9590-23c270abf309.jpg?v=1739023896",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/istanbul-icin-yaz-okulu-secenekleri-2023",
    title: "İstanbul İçin Yaz Okulu Seçenekleri / 2023",
    cat: "AKTİVİTE, SPOR",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20485_3073b112-0770-4941-b50b-cb1ef22109ed.jpg?v=1739023898",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-haziran-2023",
    title: "Çocuklarla Etkinlik Rehberi: Haziran 2023",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20483_ac951abe-7236-4545-be52-3f43046640ec.jpg?v=1739023900",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/yaslara-gore-kitap-secimi",
    title: "Yaşlara Göre Kitap Seçimi",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20481_9bf30b31-fc63-4deb-b7e4-df48bf25980f.jpg?v=1739023877",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/oyuncaklari-yeniden-kesfetmek-yaratici-oyun-cozumleri",
    title: "Oyuncakları Yeniden Keşfetmek: Yaratıcı Oyun Çözümleri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20479_b05124e2-44ed-44d6-a723-8a342f17c632.jpg?v=1739023901",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-mayis-2023",
    title: "Çocuklarla Etkinlik Rehberi: Mayıs 2023",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20477_5b715f2b-4e64-4198-92a9-60cb7ca51233.jpg?v=1739023901",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/cocuklara-yolculukta-eslik-edecek-oyun-oyuncaklar",
    title: "Çocuklara Yolculukta Eşlik Edecek Oyun / Oyuncaklar",
    cat: "SEYAHAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20471_d27f285a-6386-4f10-9ee8-c13dcd5cd285.jpg?v=1739023903",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne-hikayeleri/melike-sarikatipoglu-ve-selim",
    title: "MELİKE SARIKATİPOĞLU VE SELİM",
    cat: "ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20475_c481c806-e831-4ab7-bcfd-7b78a2f9a758.jpg?v=1739023901",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/nisan-ayinda-ekranda-olacak-ve-vizyona-girecek-yapimlar",
    title: "Nisan Ayında Ekranda Olacak ve Vizyona Girecek Yapımlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20468_32b0351c-11e7-4aab-9892-ec1e29355fdf.jpg?v=1739023904",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-nisan-2023",
    title: "Çocuklarla Etkinlik Rehberi: Nisan 2023",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20460_60a915cd-e366-4905-9cff-55b0f1c2fb94.jpg?v=1739023904",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/disney-filmlerinin-cocuklara-ogrettigi-hayat-dersleri",
    title: "Disney Filmlerinin Çocuklara Öğrettiği Hayat Dersleri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20456_c2a22ee0-0620-4935-bbfb-95ca8ec1e720.jpg?v=1739023905",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/bebeklerde-beden-gelisimini-destekleyen-urunler",
    title: "Bebeklerde Beden Gelişimini Destekleyen Ürünler",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20452_8366130b-fac9-409d-991f-3a343672b1bf.png?v=1739023906",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/cocuklara-yardimseverligin-onemini-asilamak",
    title: "Çocuklara Yardımseverliğin Önemini Aşılamak",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20449_def9274a-9fca-4cad-be2e-a8ef71a1f3f6.jpg?v=1739023907",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuk-odasi-icin-dekorasyon-onerileri",
    title: "Çocuk Odası İçin Dekorasyon Önerileri",
    cat: "EV, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20448_1_5073cc4a-8ca4-4fdc-b8bb-2ae9efedb678.jpg?v=1739023907",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/devamliligi-olan-deprem-yardimi-adresleri",
    title: "Devamlılığı Olan Deprem Yardımı Adresleri",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20446_144c0514-9f7d-49cd-a23a-1a96e9adc01b.jpg?v=1739023908",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-subat-2023",
    title: "Çocuklarla Etkinlik Rehberi: Şubat 2023",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20444_d9e976bb-5e24-4a6a-b175-b85659c77c30.jpg?v=1739023909",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklarin-hayatinda-rutinin-onemi",
    title: "Çocukların Hayatında Rutinin Önemi",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20442_0d138149-9e42-406c-86c3-f751c4a9d193.jpg?v=1739023910",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklari-temizlige-ve-duzenli-olmaya-tesvik-etmek",
    title: "Çocukları Temizliğe ve Düzenli Olmaya Teşvik Etmek",
    cat: "EBEVEYNLİK, EV, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20440_0555c1c3-9b2f-47eb-9ff7-ae41e68722ee.jpg?v=1739023911",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/yenidogan-ihtiyac-listesi",
    title: "Yenidoğan İhtiyaç Listesi",
    cat: "BAKIM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20436_ef0b00d8-045f-4229-aba1-8f03da64a780.jpg?v=1739023911",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/somestir-tatili-icin-etkinlik-onerileri",
    title: "Sömestir Tatili İçin Etkinlik Önerileri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20432.jpg?v=1739023915",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne-hikayeleri/dilan-sayrac-can-ve-beran",
    title: "DİLAN SAYRAÇ CAN VE BERAN",
    cat: "ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20430_fec11f86-ae4b-47d4-a493-9f13dc561460.jpg?v=1739023912",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/yeni-gelenler-ve-eskimeyen-klasiklerle-cocuklarla-izleyebileceginiz-yilbasi-noel-temali-yapimlar",
    title:
      "Yeni Gelenler ve Eskimeyen Klasiklerle Çocuklarla İzleyebileceğiniz Yılbaşı & Noel Temalı Yapımlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20426_1f28710f-68d8-4e4c-b7a6-637424e1a406.jpg?v=1739023914",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-aralik",
    title: "Çocuklarla Etkinlik Rehberi: Aralık",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20421_48d18211-c0a2-4efc-8e90-5a03586d83d5.jpg?v=1739023914",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/cocuklarin-burc-ozellikleri-ve-bu-ozelliklere-gore-hediye-onerileri",
    title:
      "Çocukların Burç Özellikleri ve Bu Özelliklere Göre Hediye Önerileri",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20414_2_84e49327-7497-4164-b865-94ce28c6ed3a.jpg?v=1739023916",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/ara-tatil-icin-etkinlik-onerileri",
    title: "Ara Tatil İçin Etkinlik Önerileri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20410_4383d960-0095-4872-b5b0-fa707d9cfd39.jpg?v=1739023917",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/odev-aliskanligini-destekleme",
    title: "Ödev Alışkanlığını Destekleme",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20406_a8353c40-985d-40ca-a6d7-945b205ed281.jpg?v=1739023917",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/uluslararasi-animasyon-gunu",
    title: "Uluslararası Animasyon Günü",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20404_7a6296bb-f939-45ac-92a4-004056edfba1.jpg?v=1739023919",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-kasim-2022",
    title: "Çocuklarla Etkinlik Rehberi: Kasım 2022",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20402_1_32af7b74-7fcf-4e37-833c-e6e098b8b97c.jpg?v=1739023918",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/ekrana-ve-vizyona-yeni-gelecek-yapimlar",
    title: "Ekrana ve Vizyona Yeni Gelecek Yapımlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/aya_20sihirli_1_6ff6fd13-9fef-4b49-b7e8-03ff184d8f9e.jpg?v=1739023920",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/internetle-degisen-ebeveynlik",
    title: "İnternetle Değişen Ebeveynlik",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20322_1_7e630fb1-c796-4680-ac4a-d0dd32735772.jpg?v=1739023920",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-etkinlik-rehberi-ekim-2022",
    title: "Çocuklarla Etkinlik Rehberi: Ekim 2022",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20320_96d2dab0-6102-46be-86f2-8d2bb2b44b5f.jpg?v=1739023921",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/ailece-izlenebilecek-cadilar-bayrami-ruhuna-yakisan-filmler",
    title: "Ailece İzlenebilecek Cadılar Bayramı Ruhuna Yakışan Filmler",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20318_89cab1b9-0c5d-4c1d-b7c5-1c8c8dab3b27.jpg?v=1739023922",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/anne-bebek-cantanizda-neler-olmali",
    title: "Anne Bebek Çantanızda Neler Olmalı?",
    cat: "BAKIM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20312_5ca8a2da-9ef5-4fca-84a9-a2fc919d1ddf.jpg?v=1739023923",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/akran-iliskilerinde-ailenin-konumu",
    title: "Akran İlişkilerinde Ailenin Konumu",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20303_ce7523e0-46e9-4199-84da-ace9d5d63af4.jpg?v=1739023923",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/sonbahar-temali-kitaplar",
    title: "Sonbahar Temalı Kitaplar",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20301_fa8c3f89-1440-489d-b36a-37557a4a1699.jpg?v=1739023924",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/okul-sonrasi-duygusal-zorlanma",
    title: "Okul Sonrası Duygusal Zorlanma",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20299_1_041ad566-3dcc-4c27-a147-e4b567c078fb.jpg?v=1739023925",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/emzik-hakkinda-dogru-bilinen-yanlislar",
    title: "Emzik Hakkında Doğru Bilinen Yanlışlar",
    cat: "BAKIM, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20297_d6e0e401-f8a1-4600-ac5a-a6f706de505a.jpg?v=1739023926",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/okul-temasi-iceren-filmler-ve-tv-yapimlari",
    title: "Okul Teması İçeren Filmler ve TV Yapımları",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20294_56bb66dd-8bc9-4d81-b74b-6c4d937019f8.jpg?v=1739023927",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklar-icin-okula-donus-rutinleri",
    title: "Çocuklar İçin Okula Dönüş Rutinleri",
    cat: "EBEVEYNLİK, OKUL",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20293_69fabb2a-6bd4-4817-97e2-7c059726a4bc.jpg?v=1739023927",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/okul-temali-hikaye-kitaplari",
    title: "Okul Temalı Hikaye Kitapları",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20291_1_9be5747f-2c9e-474b-b5b6-6a21c1b8707f.jpg?v=1739023928",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/damlatmaz-bardaga-gecis-sureci",
    title: "Damlatmaz Bardağa Geçiş Süreci",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20289_e2240bb9-1c67-4f2c-918c-ba7714770ee8.jpg?v=1739023929",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/deniz-kenarinda-cocuklarla-oynanabilecek-oyunlar",
    title: "Deniz Kenarında Çocuklarla Oynanabilecek Oyunlar",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20287_c3fa7db8-5350-4d4c-8902-a57333604f05.jpg?v=1739023930",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/cocuklarda-bocek-korkusu",
    title: "Çocuklarda Böcek Korkusu",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20281_34fd9e94-2533-452d-8116-a75a09ea98ff.jpg?v=1739023930",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/hamilelik/dorduncu-trimesterde-kisisel-bakim-rehberi",
    title: "Dördüncü Trimesterde Kişisel Bakım Rehberi",
    cat: "HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20268_aee8506b-0b5d-4140-ae52-40ccf4037a23.jpg?v=1739023931",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/bebek-odasindan-cocuk-odasina-gecis-icin-ipuclari",
    title: "Bebek Odasından Çocuk Odasına Geçiş İçin İpuçları",
    cat: "EV",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20270_a025177d-c51a-4d5c-8ca6-b7e18fb9e7ff.jpg?v=1739023932",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/cocuklar-icin-aktivite-kitleri",
    title: "Çocuklar İçin Aktivite Kitleri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20264_5babc273-224e-46d8-912d-2d3e4dd66ab4.jpg?v=1739023933",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/eglenceli-havuz-oyunlari",
    title: "Eğlenceli Havuz Oyunları",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20576_06c6fb32-b321-40e1-8e7b-500f43648f82.png?v=1739023935",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/cocuklara-dunyamizi-tanitan-kitaplar",
    title: "Çocuklara Dünyamızı Tanıtan Kitaplar",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/q1_3_3ceb48ec-c100-4ff3-bd0d-fae24e26b8f9.jpg?v=1739023936",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/sarilmanin-olaganustu-gucu",
    title: "Sarılmanın Olağanüstü Gücü",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/q1_2_b4f9cc1b-5088-48fa-9ce5-822ee3d62fe8.jpg?v=1739023938",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/uzay-temali-cocuk-kitaplarinin-faydalari",
    title: "Uzay Temalı Çocuk Kitaplarının Faydaları",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20232_b02e2e37-0352-4513-9cc2-cf3f76e2abd3.jpg?v=1743147439",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/bebeginizin-ilk-ucak-yolculuguna-eslik-edecek-urunler",
    title: "Bebeğinizin İlk Uçak Yolculuğuna Eşlik Edecek Ürünler",
    cat: "SEYAHAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20229_d01acbac-991d-4a55-acfd-653e5b37b703.jpg?v=1739023939",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/cocuk-odasini-duzenli-tutmak-icin-oneriler",
    title: "Çocuk Odasını Düzenli Tutmak İçin Öneriler",
    cat: "EV",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/q1_1_3302126e-3c11-46e2-8e6b-9fdb00ca15da.jpg?v=1739023939",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/18-aylik-bebekler-icin-oyuncak-onerileri",
    title: "18 Aylık Bebekler İçin Oyuncak Önerileri",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2_28_301e7276-cdb6-44ce-a23f-03c1ec854d9a.jpg?v=1739023941",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/cocuklarin-restoranda-keyifli-vakit-gecirmesi-icin-oneriler",
    title: "Çocukların Restoranda Keyifli Vakit Geçirmesi İçin Öneriler",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20220_e479c4dd-fa76-4168-b0bb-3ce6d74615d8.jpg?v=1739023941",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/odullu-kitaplar-seckisi",
    title: "Ödüllü Kitaplar Seçkisi",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20218_c7d22287-c08e-4bd7-93e5-8a46b70d3830.jpg?v=1739023942",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/sevilen-dizi-karakterleri-ile-populerlesen-isimler",
    title: "Sevilen Dizi Karakterleri İle Popülerleşen İsimler",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20210_6c749e9f-44b3-449b-9ceb-80866945fef1.jpg?v=1739023943",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/nisan-ayinda-ekranda-olacak-cocuk-filmleri",
    title: "Nisan Ayında Ekranda Olacak Çocuk Filmleri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20207_0112a36d-ba22-4e1d-9e6d-919000fed1eb.jpg?v=1739023944",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/oyuncak-mutfak-setiyle-oynamanin-faydalari",
    title: "Oyuncak Mutfak Setiyle Oynamanın Faydaları",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/q2_38b13f86-2b39-4876-a4bb-e016dd24265b.jpg?v=1739023948",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/okul-oncesi-favori-etkinlik-kitaplari",
    title: "Okul Öncesi Favori Etkinlik Kitapları",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20200_353937b5-abe1-4263-81ed-da15ffc9c721.jpg?v=1739023949",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklara-ilkbahar-modunu-yasatacak-filmler",
    title: "Çocuklara İlkbahar Modunu Yaşatacak Filmler",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/a2_e2298b43-5b26-4c98-a792-b23a22ac83af.jpg?v=1739023949",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/farkli-kategorilerde-hazine-avi",
    title: "Farklı Kategorilerde Hazine Avı",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/WhatsApp_20Image_202021-06-11_20at_2015.37.50_3fa82623-ced4-4111-8e46-974c547513cd.jpg?v=1739023952",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/oyun/eglenceli-su-oyuncaklari",
    title: "Eğlenceli Su Oyuncakları",
    cat: "OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/su_20oyuncaklar_c4_b1_fc2b4e58-98b3-4558-ba1a-6bd15382c690.jpg?v=1739023952",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/araba-yolculuklarinda-cocuklara-eslik-edecek-podcast-onerileri",
    title: "Araba Yolculuklarında Çocuklara Eşlik Edecek Podcast Önerileri",
    cat: "YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20497_1_24e404e7-069c-494a-9aa7-4d21eacb6d27.jpg?v=1739023954",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-cikmaniz-gereken-6-sanal-tur",
    title: "Çocuklarla Çıkmanız Gereken 6 Sanal Tur",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/boston_20museum_013ed0aa-74cf-49e2-bf00-264886edea44.jpg?v=1739023958",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/cocuklar-icin-eglence-garantili-ev-aktiviteleri",
    title: "Çocuklar İçin Eğlence Garantili Ev Aktiviteleri",
    cat: "AKTİVİTE, OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/GOLGE_20GEORGIE_1_d65ce51f-51df-47fe-a7bc-46ea92252184.jpg?v=1739023956",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/evden-calisan-annelere-ipuclari",
    title: "Evden Çalışan Annelere İpuçları",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-05-10_2011.04.39_8713a6e9-5680-4e9f-9879-c9a29523b599.png?v=1739023959",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuk-gelisim-uzmanlari-tarafindan-onerilen-yapimlar",
    title: "Çocuk Gelişim Uzmanları Tarafından Önerilen Yapımlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/storybots_59d24e44-4c99-4872-bcf9-869beebb608d.jpg?v=1739023959",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/sinema-gecesi-icin-klasik-aile-filmleri",
    title: "Sinema Gecesi İçin Klasik Aile Filmleri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ratatouille_64d1446b-f9f2-4193-bb04-715455f6ed21.jpg?v=1739023958",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/bahcenizde-ya-da-balkonunuzda-bir-sebze-meyve-bahcesi-olusturmanin-yollari",
    title:
      "Bahçenizde ya da Balkonunuzda Bir Sebze/Meyve Bahçesi Oluşturmanın Yolları",
    cat: "EV, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/TheSageGarden_harvestingduo_1f69ccba-5cc1-4e7f-a64b-d6347da2612a.jpg?v=1739023961",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/hayvanlari-seven-cocuklar-icin-ilgi-cekici-yapimlar",
    title: "Hayvanları Seven Çocuklar İçin İlgi Çekici Yapımlar",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/AAAABWrY8Pn1OXrXgyAS9g0iZyiagi7PwaiaSmN9wK2uKOQNvaXG6TDDA7-aXQInmreDCJbkcTnxp3FlshpP3E5Sk2ZD8nlW_c870fa93-2941-42bb-8b1a-393ec3d8016f.jpg?v=1739023961",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/ilhamini-ilkbahardan-alan-isimler",
    title: "İlhamını İlkbahardan Alan İsimler",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/wheatdk_de849732-319d-44bd-a2f1-4cf47a2ea3c3.png?v=1739023964",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/bahar-temizligi-yapmamiz-gereken-7-yer",
    title: "Bahar Temizliği Yapmamız Gereken 7 Yer",
    cat: "EV, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-04-13_2014.45.55_daceac21-1e82-45dc-9281-fe21be42ee23.png?v=1739023965",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/annelik-gercekleri/pandemide-tukenmis-anneler-toplanin-sarjinizi-doldurabilecek-10-onerimiz-var",
    title:
      "Pandemide Tükenmiş Anneler Toplanın: Şarjınızı Doldurabilecek 10 Önerimiz Var",
    cat: "ANNELİK GERÇEKLERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/burnout-mom_f1dbac30-5588-43f6-90da-a79ae1b72904.jpg?v=1739023968",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/buyumeden-okunacak-101-kitap",
    title: "Büyümeden Okunacak 101 Kitap",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/reading_2_008d0249-2d79-4263-be80-4cfa4eb28d05.jpg?v=1739023963",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/beslenmeye-dair-bakis-acinizi-degistirecek-belgeseller",
    title: "Beslenmeye Dair Bakış Açınızı Değiştirecek Belgeseller",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/f54785b9157614d6a95c1ae1a00fc508_1188e583-4ae0-45a0-a722-04aad63ccd9a.jpg?v=1739023969",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/korkularla-ilgili-cocuk-kitaplari",
    title: "Korkularla İlgili Çocuk Kitapları",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/korkular_20kapak_61863088-b07f-4362-b8dc-f3eeeed7410b.jpg?v=1739023973",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/annelik-gercekleri/evimizden-uzaktaki-evimiz",
    title: "Evimizden Uzaktaki Evimiz",
    cat: "ANNELİK GERÇEKLERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PXL_20210117_010201516.PORTRAIT_25cc6ce4-202e-493e-a655-2762c90440ca.jpg?v=1739023976",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklar-icin-cevrimici-atolyeleri-olan-yerli-ve-yabanci-muzeler",
    title: "Çocuklar İçin Çevrimiçi Atölyeleri Olan Yerli ve Yabancı Müzeler",
    cat: "KÜLTÜR SANAT, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Royal-Academy-of-Arts_60a1ec4f-cdb6-498d-830b-0cd18b4118c1.jpg?v=1739023955",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/petitmag-okuyucularina-ozel-boyama-sayfasi",
    title: "Petitmag Okuyucularına Özel Boyama Sayfası",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/boyama-sayfas_c4_b15555_3ebd4a5b-0420-4475-9356-f53142207316.jpg?v=1739023979",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/paylasma-temali-cizgi-film-bolumleri",
    title: "Paylaşma Temalı Çizgi Film Bölümleri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Puffin-Rock-Visuel-3_1c03fb95-5707-495b-bce7-6dade8d8fd54.jpg?v=1739023969",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/finlandiyali-bebekler-neden-karton-kutuda-uyuyor",
    title: "Finlandiyalı Bebekler Neden Karton Kutuda Uyuyor?",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/original_f35b9b07-0fab-4f25-a129-b0da6780465b.jpg?v=1739023984",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/hamilelik/hamilelik-doneminde-bebeginizle-iletisime-gecmenin-6-yolu",
    title: "Hamilelik Döneminde Bebeğinizle İletişime Geçmenin 6 Yolu",
    cat: "HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-03-24_2015.58.22_03a71ae4-02cc-410c-b5bb-1119fd747940.png?v=1739023973",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/menstrual-dongude-yoga-yapilmali-mi",
    title: "Menstrual Döngüde Yoga Yapılmalı mı?",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Untitled_Artwork_e9240251-28f1-482c-beda-abde3462a74f.jpg?v=1739023976",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/hamilelik-doneminde-aromaterapi-yaglari-dogru-bilinen-yanlislar",
    title: "Hamilelik Döneminde Aromaterapi Yağları: Doğru Bilinen Yanlışlar",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-03-12_2015.48.59_677ca55c-413d-4f9b-b33f-bbab657e2e14.png?v=1739023977",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/evden-calisirken-hazirlayabileceginiz-5-pratik-ogle-yemegi-tarifi",
    title: "Evden Çalışırken Hazırlayabileceğiniz 5 Pratik Öğle Yemeği Tarifi",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/egg_rolls_46445_16x9_4_11fe6211-d8dd-46f2-930c-e5bc214f89ab.jpg?v=1739023984",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kitap/duygulari-tanimakla-ilgili-cocuk-kitaplari",
    title: "Duyguları Tanımakla İlgili Çocuk Kitapları",
    cat: "KİTAP",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/myheart_luyken0_3a15254f-d589-4ef3-b047-125aeb0db6bc.jpg?v=1739023976",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/toksinlerden-uzak-alisveris-rehberi",
    title: "Toksinlerden Uzak Alışveriş Rehberi",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_7856_4a11ddf9-1fc0-4cb3-a812-beba221b01a1.jpg?v=1739023983",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/karbon-ayak-izinizi-azaltmanin-yollari",
    title: "Karbon Ayak İzinizi Azaltmanın Yolları",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-03-01_2014.52.38_36f886fa-5fc2-46c6-9fb4-b7e069cb0dba.png?v=1739023987",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklarda-fiziksel-sinirlari-korumak",
    title: "Çocuklarda Fiziksel Sınırları Korumak",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2019-04-19_86728c8f-2e18-4a82-8df9-421c0bdfb2ac.jpg?v=1739023979",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cizgi-filmlerin-ilham-veren-guclu-kiz-karakterleri",
    title: "Çizgi Filmlerin İlham Veren Güçlü Kız Karakterleri",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/stealla_20and_20sam_2_98387a53-dcca-4055-b8a4-73438b308fe2.jpg?v=1739023990",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklar-icin-egitici-mobil-uygulamalar",
    title: "Çocuklar İçin Eğitici Mobil Uygulamalar",
    cat: "TEKNOLOJİ, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/f479f8773f8bfe571cf20e13ed987f46_a22f00b8-00e2-445d-b551-0640d60b9c1e.jpg?v=1739023986",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocukluk-cagi-gelisimsel-korkulari",
    title: "Çocukluk Çağı Gelişimsel Korkuları",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-03-09_2016.19.26_e6d9f74a-049d-46b8-95af-9b829231600f.png?v=1739023980",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/kiyafet-secimi-savasa-donusmesin",
    title: "Kıyafet Seçimi Savaşa Dönüşmesin",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1582_5d4db08d-4f02-42cf-978f-7541f12c1e02.jpg?v=1739023983",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/lohusalik-doneminde-bedene-ve-ruha-iyi-gelen-caylar",
    title: "Lohusalık Döneminde Bedene ve Ruha İyi Gelen Çaylar",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-23_2013.04.04_e6a1dd26-621f-40f1-b5d3-a91874f608d7.png?v=1739023995",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklar-tek-basina-oyun-oynar-mi",
    title: "Çocuklar Tek Başına Oyun Oynar mı?",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/habitacion-para-varios-hermanos_27574600_89366027-873f-44e2-92a7-656cc9298831.jpg?v=1739023987",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/hayatin-dengesi-ayurveda",
    title: "Hayatın Dengesi: Ayurveda",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-22_2011.26.57_e071c2e6-faf5-433f-bd1d-29b506cd04aa.png?v=1739023996",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/besikten-cocuk-yatagina-gecis-sureci-hakkinda-bilmeniz-gerekenler",
    title: "Beşikten Çocuk Yatağına Geçiş Süreci Hakkında Bilmeniz Gerekenler",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-25_2015.06.51_beedaa11-54dc-4218-bd55-c7b90ac856bc.png?v=1739023991",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/hamilelik/emzirme-doneminde-sut-artirmaya-yardimci-besinler",
    title: "Emzirme Döneminde Süt Artırmaya Yardımcı Besinler",
    cat: "HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-03-09_2011.47.18_4076f6c2-8998-40e7-ab19-fa1af7b78ad7.png?v=1739023980",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/hamilelik/prenatal-yoganin-anne-ve-bebege-faydalari",
    title: "Prenatal Yoganın Anne ve Bebeğe Faydaları",
    cat: "HAMİLELİK, SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/WhatsApp_20Image_202021-02-16_20at_2012.32.51_92f68f66-e867-47bd-a428-0762804a4c62.jpg?v=1739023999",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/ogretmek-ya-da-ogretmemek-iste-butun-mesele-bu",
    title: "Öğretmek Ya da Öğretmemek, İşte Bütün Mesele Bu!",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/timthumb_1_15fd61bc-d25f-473f-8456-74a7f5d6a93d.jpg?v=1739024003",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklara-paylasmayi-ogretmeli-miyiz-nasil",
    title: "Çocuklara Paylaşmayı Öğretmeli miyiz? Nasıl?",
    cat: "EBEVEYNLİK, GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-11_2011.34.37_99e2125f-052e-421e-a9d5-73d9db7dfeb2.png?v=1739024002",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/tup-bebek-tedavisinde-psikolojik-destegin-onemi",
    title: "Tüp Bebek Tedavisinde Psikolojik Desteğin Önemi",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-24_2015.09.51_e6477846-e6bb-4560-9635-bd7e0057f038.png?v=1739023991",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklara-neden-zorla-ozur-diletmemeliyiz",
    title: "Çocuklara Neden Zorla Özür Diletmemeliyiz?",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ocuklar__c3_b6z_c3_bcr_412f7264-1f6a-4b6b-a0fe-fbb7b9b5cb42.jpg?v=1740732037",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/populer-ev-bitkileri-rehberi",
    title: "Popüler Ev Bitkileri Rehberi",
    cat: "EV",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/timthumb_2_c28ffe46-fb6b-4dab-b328-a177effb66a1.jpg?v=1739024003",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklara-para-kavramini-ogretmek",
    title: "Çocuklara Para Kavramını Öğretmek",
    cat: "EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1871_d28b3a7a-8cc5-44b3-9310-694b6bb414eb.jpg?v=1739023999",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklara-iklim-krizini-anlatan-belgeseller",
    title: "Çocuklara İklim Krizini Anlatan Belgeseller",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/before_20the_20flood_7c49a52e-4cf4-4d9d-994e-b23609a66f2a.jpg?v=1739024006",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/guvenli-babywearing-rehberi",
    title: "Güvenli Babywearing Rehberi",
    cat: "BAKIM, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-02-17_2009.33.00_8f920df5-1697-4565-9596-18c45c1ca935.png?v=1739023999",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/ara-tatilde-cocuklarin-gunlerini-yapilandirmak-icin-oneriler",
    title: "Ara Tatilde Çocukların Günlerini Yapılandırmak İçin Öneriler",
    cat: "AKTİVİTE, OYUN",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-01-29_2016.10.26_fa52fed5-243d-478d-a82a-c68ec17e88a5.png?v=1739024010",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/cocuklari-cevrimici-dunyada-guvende-tutmanin-yollari",
    title: "Çocukları Çevrimiçi Dünyada Güvende Tutmanın Yolları",
    cat: "EBEVEYNLİK, TEKNOLOJİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PRINTED-WALLS-IN-KIDS-ROOMS5_ebecfde3-409d-465f-bc18-b0ed73fe7086.jpg?v=1739023998",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/dis-cikarma-hakkinda-bilmeniz-gerekenler",
    title: "Diş Çıkarma Hakkında Bilmeniz Gerekenler",
    cat: "GELİŞİM, SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/1c64e727-a506-49a8-8edd-dac9be177541_457f1250-6f22-4138-8ef3-162cd944cced.jpg?v=1739024006",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/kuculen-kiyafetleri-ve-artik-oynanmayan-oyuncaklari-degerlendirme-yontemleri",
    title:
      "Küçülen Kıyafetleri ve Artık Oynanmayan Oyuncakları Değerlendirme Yöntemleri",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/tes12-575x719_ff4c4d34-0c49-4364-a721-a752f84227d8.jpg?v=1739024015",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/infertilite-ve-tup-bebek-tedavisi-hakkinda-merak-edilenler",
    title: "İnfertilite ve Tüp Bebek Tedavisi Hakkında Merak Edilenler",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Writers-Club-Winner-Bettmann-Man-Repeller-January-2018-514902652-copy_982662eb-bab8-4d81-b9e2-d999b45e001b.jpg?v=1739024013",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/postpartum-depresyonu-deneyimler-kisisel-olsa-da-yasanan-duygular-ortak",
    title:
      "Postpartum Depresyonu: Deneyimler Kişisel Olsa da Yaşanan Duygular Ortak",
    cat: "ANNE, EBEVEYNLİK, SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/postpartum_web_g_c3_b6rsel_96702629-5f74-4f6e-ad94-c7793b569708.jpg?v=1739024016",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/menstrual-kap-hakkinda-bilmeniz-gereken-her-sey",
    title: "Menstrual Kap Hakkında Bilmeniz Gereken Her Şey",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Menstural_Kolaj_eeda1eeb-966a-4371-980e-b6877ac405b2.jpg?v=1739024017",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/lohusalik-doneminde-yasanan-sac-dokulmesi-hakkinda-bilmeniz-gerekenler",
    title:
      "Lohusalık Döneminde Yaşanan Saç Dökülmesi Hakkında Bilmeniz Gerekenler",
    cat: "SAĞLIK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/5_20Questions_20Im_20Glad_20I_20Asked_20During_20Labor_8edbe5da-9e8d-4319-80a7-58dd887cd639.jpg?v=1739024007",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/2-yas-sendrom-mu-donem-mi",
    title: "2 Yaş: Sendrom mu? Dönem mi?",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2_20ya_c5_9f_20anna_20kubel_86799d8f-627c-44c7-994f-e412cce7d1e9.jpg?v=1739024020",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/kardes-catismalarina-ebeveyn-olarak-nasil-yaklasilmali",
    title: "Kardeş Çatışmalarına Ebeveyn Olarak Nasıl Yaklaşılmalı?",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/DSC08127_14561160-7bf2-4024-8c28-2cc05f995f04.jpg?v=1739024014",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklara-kayip-ve-olumu-anlatmak",
    title: "Çocuklara Kayıp ve Ölümü Anlatmak",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Ekran_20Resmi_202021-01-06_2014.09.47_f0ba492c-1c41-4b0d-968a-126e3ea25e15.png?v=1739024017",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/petitmag-kis-temali-boyama-sayfalari",
    title: "Petitmag Kış Temalı Boyama Sayfaları",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/5E0B6565-FBBB-4B7A-8230-A618434D4381_bc13c1d3-e91a-4d2e-84e0-d51a7040fd65.jpg?v=1739024021",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-izlenebilecek-yeni-yil-temali-filmler",
    title: "Çocuklarla İzlenebilecek Yeni Yıl Temalı Filmler",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/HomeAlone_ce4ecda9-dfb2-43f6-b208-ee697c65cc7f.jpg?v=1739024021",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/yeni-yil-temali-filmler",
    title: "Yeni Yıl Temalı Filmler",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/BridgetJonesDiary_e34b5d80-37c2-4a24-926d-be251dd476c3.jpg?v=1739024022",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/0-6-ay-bebeklerle-nasil-oyunlar-oynayabiliriz",
    title: "0-6 Ay Bebeklerle Nasıl Oyunlar Oynayabiliriz?",
    cat: "GELİŞİM, OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/beg_c3_bcm_20k_c3_b6seler_20bebek_20oyun_20_8a13ac8e-068b-4faf-9f98-9d39f8467317.jpg?v=1739024025",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/ebeveynlikle-ilgili-20-harika-film",
    title: "Ebeveynlikle İlgili 20 Harika Film",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/tumblr_pa4hu5tPju1vg8zzho1_500_1_85a4cfb2-c63c-4d31-977a-7be52b75cc9c.jpg?v=1739024026",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/petit-mahalle-gozde-kumru-ucak-ile-moda",
    title: "Petit Mahalle: Gözde Kumru Uçak ile Moda",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_2432-1_20copy_dedf2a9c-4cea-4ef0-b67f-3bbeea3ce219.jpg?v=1739024025",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/yasamin-ilk-yillarinda-muzigin-yeri",
    title: "Yaşamın İlk Yıllarında Müziğin Yeri",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Music_29dd4d24-b16a-4622-a434-3c5f1e651f62.jpg?v=1739024027",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/yagmurlu-havalar-icin-favori-urunlerimiz",
    title: "Yağmurlu Havalar İçin Favori Ürünlerimiz",
    cat: "",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/umbrella-long_4874f1a0-fd74-47a0-ae7b-89ef1fde7855.jpg?v=1739024029",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklardan-ve-genclerden-ilham-veren-ted-konusmalari",
    title: "Çocuklardan ve Gençlerden İlham Veren TED Konuşmaları",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/MemoryBanda_af42842f-0ec6-4e81-8007-e7f9f02449a6.jpg?v=1739024030",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/cocuklar-icin-problem-cozme-temali-10-kisa-film",
    title: "Çocuklar İçin Problem Çözme Temalı 10 Kısa Film",
    cat: "AKTİVİTE, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Piper_3adf28e9-c3d7-4462-b646-d65301aa523a.jpg?v=1739024029",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/sonbahar-ruhunu-yasatan-filmler",
    title: "Sonbahar Ruhunu Yaşatan Filmler",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Stepmom_4dcc6a45-49b3-450c-bdd4-4503cd575121.jpg?v=1739024033",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/dunyanin-en-guzel-cocuk-parklari",
    title: "Dünyanın En Güzel Çocuk Parkları",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/HakunaWoodsOfNet_606f1a61-8f0c-481b-8c55-9aeb28abbf1f.jpg?v=1739024031",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/cocuklara-tuvalet-aliskanligi-kazandirirken-nasil-bir-yol-izlenmeli",
    title:
      "Çocuklara Tuvalet Alışkanlığı Kazandırırken Nasıl Bir Yol İzlenmeli?",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PT_80c03c5d-e345-449f-8aae-5b4ed963d75a.jpg?v=1739024032",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/bahar-temizliginde-muhtemelen-gozden-kacirdiginiz-yerler",
    title: "Bahar Temizliğinde (Muhtemelen) Gözden Kaçırdığınız Yerler",
    cat: "EV",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/20160120-DamselinDior21709-1280x853_fa08afd0-0df7-42c5-849b-46d54c4a0aa5.jpg?v=1739024034",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/buzdolabini-duzenli-tutmanin-ve-gidalarinizin-tazeligini-daha-uzun-sure-korumanin-yollari",
    title:
      "Buzdolabını Düzenli Tutmanın ve Gıdalarınızın Tazeliğini Daha Uzun Süre Korumanın Yolları",
    cat: "MUTFAK, SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2020-07-23-07-52-48_27e0f12d-de1f-4d69-83ef-a39a05cbb003.jpg?v=1739024036",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/petitmag-yaz-kampi-hazine-avi",
    title: "Petitmag Yaz Kampı Hazine Avı",
    cat: "AKTİVİTE, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/20-24-Temmuz-Petitmag-Kap_e82f9734-dbc5-410b-bbf4-2b597eb13e66.jpg?v=1739024036",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/yuzme-egitmeni-mehmet-vefa-ile-bebek-ve-cocuklarda-yuzme-egitimi-uzerine",
    title:
      "Yüzme Eğitmeni Mehmet Vefa ile Bebek ve Çocuklarda Yüzme Eğitimi Üzerine",
    cat: "SPOR, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Mehmet_20Vefa_20il_c3_bcstrasyon_Fotor_93f7febc-8d70-47bf-be1f-1919b47a1665.jpg?v=1739024038",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklar-ve-aileler-icin-keyifli-yaz-oyunlari",
    title: "Çocuklar ve Aileler İçin Keyifli Yaz Oyunları",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4813-1_20copy_Fotor_37f8bf8b-7b70-4b13-b15c-a8619a0235d4.jpg?v=1739024038",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/evsel-atiklarimizi-azaltmak-icin-neler-yapiyoruz",
    title: "Evsel Atıklarımızı Azaltmak İçin Neler Yapıyoruz?",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image0-3_1_d85b1d99-8998-4e3f-b4ee-64e194c0e08b.jpg?v=1739024040",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/beslenme-uzmani-raysa-buyukbahar-uzunyol-ile-dogum-sonrasi-beslenme",
    title:
      "Beslenme Uzmanı Raysa Büyükbahar Uzunyol ile Doğum Sonrası Beslenme",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2020-06-14-15-45-41_b1c3a200-638f-49a7-8979-33cc113bd7a8.jpg?v=1739024040",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/buse-terim-bahcekapili-ve-nil-naz",
    title: "Buse Terim Bahçekapılı ve Nil & Naz",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20154_3c409ff0-82dd-48fb-9e35-8a03edb7822b.jpg?v=1739024042",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/montessori-felsefesine-uygun-cocuk-odasi-tasarlamak",
    title: "Montessori Felsefesine Uygun Çocuk Odası Tasarlamak",
    cat: "EV, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/thalieandco_Fotor_fcdc7406-f128-4c0e-9779-e6e163006cee.jpg?v=1739024044",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/regl-dongusu-ve-dogurganlik-takibi-icin-bes-mobil-uygulama",
    title: "Regl Döngüsü ve Doğurganlık Takibi için Beş Mobil Uygulama",
    cat: "ANNE, HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image0-3_00f09b2e-46a6-41bf-9f26-e26e0d97a338.jpg?v=1739024044",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/cocuklarla-bahar-temizligi",
    title: "Çocuklarla Bahar Temizliği",
    cat: "AİLE, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Cleaning-Caddy-Essentials-14_73717c27-e3c7-475f-b662-dfd0f454ecb9.jpg?v=1739024046",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/okullar-kapaliyken-cocuklarla-evde-yapilabilecek-aktiviteler",
    title: "Okullar Kapalıyken Çocuklarla Evde Yapılabilecek Aktiviteler",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/00A6252-1_20copy_Fotor_99a89103-c82a-43cc-81dc-d2c0eadeafd4.jpg?v=1739023951",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/belkis-boyacigiller-ve-mey",
    title: "Belkıs Boyacıgiller ve Mey",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2_11_c071d7b0-cc6f-450b-aef3-67ac67f10267.jpg?v=1739024048",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklar-icin-eglenceli-ve-egitici-televizyon-yapimlari",
    title: "Çocuklar İçin Eğlenceli ve Eğitici Televizyon Yapımları",
    cat: "TEKNOLOJİ, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ocuk-filmleri_bd44d00d-e9d6-4086-b2d5-576ad61d14c0.jpg?v=1739024049",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/evde-oyun-hamuru-tarifi",
    title: "Evde Oyun Hamuru Tarifi",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-7_d26956c0-98f7-4001-827c-0660755f9432.jpg?v=1739024050",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/giyim/kis-aylarinda-bebekler-ve-cocuklar-nasil-giydirilmeli",
    title: "Kış Aylarında Bebekler ve Çocuklar Nasıl Giydirilmeli?",
    cat: "GİYİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/00A6527-1_20copy_07d07b3e-8993-4e60-beb9-a495e373e45f.jpg?v=1739024052",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/nur-fettahoglu-ve-elisa",
    title: "Nur Fettahoğlu ve Elisa",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/1_12_d3f91d68-34f0-4980-bf87-efd9b1c0b649.jpg?v=1739024052",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/cocugunuz-hastayken-onu-evde-nasil-oyalayabilirsiniz",
    title: "Çocuğunuz Hastayken Onu Evde Nasıl Oyalayabilirsiniz?",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kapak_20the_20hobbs_20farm_7ea44dc5-bfaf-49c1-bd2c-4b451f4c843d.jpg?v=1739024053",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/besikten-yataga-gecis-sureci",
    title: "Beşikten Yatağa Geçiş Süreci",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/timthumb_1_f2c33f5b-83e8-4760-b7be-acd73dae3025.jpg?v=1739024054",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklari-bagimsiz-oyun-oynamaya-nasil-tesvik-edebiliriz",
    title: "Çocukları Bağımsız Oyun Oynamaya Nasıl Teşvik Edebiliriz",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_8780-1_1_cc975bd8-5751-4674-a162-a582d2c8fb95.jpg?v=1739024056",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/beklenmedik-ve-travmatik-yasam-olaylarini-cocuklara-anlatmanin-yollari",
    title:
      "Beklenmedik ve Travmatik Yaşam Olaylarını Çocuklara Anlatmanın Yolları",
    cat: "YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_8959_6853aadb-d6e4-4fb2-84c4-df737b306414.jpg?v=1739024056",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/okul-oncesi-icin-montessori-aktivitesi-onerileri",
    title: "Okul Öncesi için Montessori Aktivitesi Önerileri",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4811-1_20copy_e322ec6b-6e0e-4736-8374-878a3a730103.jpg?v=1739024057",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/dogumdan-sonra-google-a-en-cok-sorulan-sorular",
    title: "Doğumdan Sonra Google’a En Çok Sorulan Sorular",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4978-3_20copy_00f1875e-66d1-40e7-8c33-dc47a638e33e.jpg?v=1739024058",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/gelisim/cocuklara-ogrenme-sevgisi-asilamanin-yollari",
    title: "Çocuklara Öğrenme Sevgisi Aşılamanın Yolları",
    cat: "GELİŞİM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_8829-1_61f4c305-c894-43d0-8eb8-edd60b10b62a.jpg?v=1739024060",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/yenidogan-bebeklerde-gaz-sorunu-icin-oneriler",
    title: "Yenidoğan Bebeklerde Gaz Sorunu İçin Öneriler",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4724-1_20copy_7f8138ee-ffe2-4463-9166-206744541560.jpg?v=1739024060",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/okulun-ilk-gununde-ayrilik-kaygisi-ve-oneriler",
    title: "Okulun İlk Gününde Ayrılık Kaygısı ve Öneriler",
    cat: "OKUL, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_7779_fa63295d-41ec-45df-a0fc-304f5b747552.jpg?v=1739024061",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/ilkokula-baslayan-cocuklar-icin-tavsiyeler-okullar-acilmadan",
    title: "İlkokula Başlayan Çocuklar İçin Tavsiyeler: Okullar Açılmadan",
    cat: "OKUL, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4946-3_20copy_04c8d725-a1ce-4d1e-bbb2-e5865e8fda70.jpg?v=1739024062",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/okul-acilirken-bagisiklik-sistemini-guclendirmenin-yollari",
    title: "Okul Açılırken Bağışıklık Sistemini Güçlendirmenin Yolları",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4652-1_20copy_6da5290b-ebac-45b0-aebf-69dfbd7347ee.jpg?v=1739024064",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-birlikte-izlenebilecek-1980-ler-filmleri",
    title: "Çocuklarla Birlikte İzlenebilecek 1980’ler Filmleri",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/annie_20kapak_1c2f151c-047a-4453-87ec-3f215088110e.jpg?v=1739024065",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/yaz-mevsiminde-uyku-rutinini-surdurmenin-yollari",
    title: "Yaz Mevsiminde Uyku Rutinini Sürdürmenin Yolları",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-6_2_1252c84c-8c4a-446c-ab88-f9887018c51d.jpg?v=1739024066",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/sut-sagarken-sikilanlara-oneriler",
    title: "Süt Sağarken Sıkılanlara Öneriler",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/047abb02-5ea9-403d-a5f3-e63d12c72424-rebeccaminkoffromper-1_6180ed5f-d251-4c46-8ded-ab6fcad9e765.jpg?v=1739024068",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/bebekle-ucak-yolculugu-hakkinda-bilmeniz-gereken-her-sey",
    title: "Bebekle Uçak Yolculuğu Hakkında Bilmeniz Gereken Her Şey",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/chriselle_20lim_323d6483-9058-4458-98f7-cb9ce1ca1a61.jpg?v=1739024068",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/bebeginizin-ilk-yili-icin-oyun-onerileri",
    title: "Bebeğinizin İlk Yılı İçin Oyun Önerileri",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_3963-1_20copy_Fotor_53e28043-81a7-4a95-a6b4-385d9bb48ddd.jpg?v=1739024069",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/ispanakli-kuskus",
    title: "Ispanaklı Kuskus",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_4788-1_20copy_3b50e4ee-3a59-49be-ad99-59a94d63860f.jpg?v=1739024072",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/cocuklu-evde-yemek-hazirliklarini-kolaylastirmanin-yollari",
    title: "Çocuklu Evde Yemek Hazırlıklarını Kolaylaştırmanın Yolları",
    cat: "MUTFAK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kapak_2_ed54def8-290b-4600-b912-e2e92a36c18e.jpg?v=1739024072",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/orada-olmak",
    title: "Orada Olmak",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_9134-1_d99dc3ca-9d76-48e8-9a83-25f36abb4249.jpg?v=1739024073",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/petit-liste-bebekle-uzun-yolculuk",
    title: "Petit Liste: Bebekle Uzun Yolculuk",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-5_2b7d06d8-9fde-4029-82d4-af3b651d1c0f.jpg?v=1739024074",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/oynarken-gelistiren-oyuncaklar",
    title: "Oynarken Geliştiren Oyuncaklar",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/EmptyName_2083_5a9e9837-e4c1-450a-a7c1-2b2eca70e124.jpg?v=1739024076",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/ikinci-hamilelikte-hayati-kolaylastiran-birkac-ipucu",
    title: "İkinci Hamilelikte Hayatı Kolaylaştıran Birkaç İpucu",
    cat: "ANNE, HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_9776_620b200b-3e02-4a7b-92f7-89c9be20f679.jpg?v=1739024076",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/annelikte-ikinci-cocuk-guncellemesi-vicdan-azabi",
    title: "Annelikte İkinci Çocuk Güncellemesi: Vicdan Azabı",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kaya_may2018-24_Fotor_3d341a4d-9bc8-415d-948e-046efa9c1817.jpg?v=1739024076",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/evden-calisan-anne-olmak",
    title: "Evden Çalışan Anne Olmak",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-4_4_040da3b9-22c4-45d2-89f0-d094a16bad9f.jpg?v=1739024077",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/bir-annenin-sut-sagmakla-ilgili-tum-tecrubeleri",
    title: "Bir Annenin Süt Sağmakla İlgili Tüm Tecrübeleri",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kaya_june2017-120_Fotor_9df43eea-bf28-468b-8155-489f57a97ed1.jpg?v=1739024080",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/petit-sehir-rehberi-serra-yenturk-ve-leyla-ile-paris",
    title: "Petit Şehir Rehberi: Serra Yentürk ve Leyla ile Paris",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/serra_20leyla_20paris_f19dce6b-748b-4c17-8387-04094466589c.jpg?v=1739024080",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/evin-ve-vera-ile-kati-gidaya-gecis-rehberi",
    title: "Evin ve Vera ile Katı Gıdaya Geçiş Rehberi",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_8608-1_227a83fd-c679-4614-bc45-71f65a43828f.jpg?v=1739024080",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-birlikte-izlenebilecek-10-belgesel",
    title: "Çocuklarla Birlikte İzlenebilecek 10 Belgesel",
    cat: "KÜLTÜR SANAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/keyart_Fotor_1_7971774c-702e-4c72-964f-8535b27fef33.jpg?v=1739024081",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ev/cocuklar-icin-yilbasi-sofrasi",
    title: "Çocuklar İçin Yılbaşı Sofrası",
    cat: "EV, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_5632-1_20copy_c2a86124-856b-4cf0-b965-d63073133f18.jpg?v=1739024084",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/annelik-gercekleri/annelik-gercekleri-annem-olmadan-anne-olmayi-ogrenmek",
    title: "Annelik Gerçekleri: Annem Olmadan Anne Olmayı Öğrenmek",
    cat: "ANNELİK GERÇEKLERİ, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/d16658ab-1463-4784-99e3-a056fbf555ac_28d35d43-4c72-4b24-b758-cd800ec3e393.jpg?v=1739024084",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/iki-cocukla-yardimsiz-hayatta-kalma-rehberi",
    title: "İki Çocukla Yardımsız Hayatta Kalma Rehberi",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-3_4_bb5294b0-a08f-4861-a4f8-63a7e6216141.jpg?v=1739024084",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/premature-farkindalik-ayi-ozel-roportaji-irem-guzey-ve-mert",
    title: "Prematüre Farkındalık Ayı Özel Röportajı: İrem Güzey ve Mert",
    cat: "ANNE, EBEVEYNLİK, HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ZG_9874-1_Fotor_9e47bec9-1ebc-4cb6-9ed8-42fd42cab819.jpg?v=1739024085",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/sekersiz-hindistan-cevizli-yulaf-toplari",
    title: "Şekersiz Hindistan Cevizli Yulaf Topları",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/9e05e4b9-a07b-4906-8679-a7a021e3276c_7da71e43-a8bc-4d9a-a2c6-a03e5d372964.jpg?v=1739024088",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/annelik-gercekleri/annelik-gercekleri-bilingual-cocuk-nasil-yetistirilir",
    title: "Annelik Gerçekleri: Bilingual Çocuk Nasıl Yetiştirilir?",
    cat: "ANNELİK GERÇEKLERİ, EBEVEYNLİK, GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_0763_b313b3f7-1837-4f02-8748-13e8bd397619.jpg?v=1739024088",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocugunuz-icin-nasil-daha-iyi-bir-dinleyici-olursunuz",
    title: "Çocuğunuz İçin Nasıl Daha İyi Bir Dinleyici Olursunuz?",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/iyi_20dinleyici_20olmak_a116f1a4-f51b-48c5-890f-5dc8ba79b880.jpg?v=1739024089",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/annelik-gercekleri-anne-zorbaligi",
    title: "Annelik Gerçekleri: Anne Zorbalığı...",
    cat: "ANNE, ANNELİK GERÇEKLERİ, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-10-16-12-53-10_a02b9496-cd86-461c-9af0-3648a6b3f664.jpg?v=1739024092",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/yaban-mersinli-muffin",
    title: "Yaban Mersinli Muffin",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-10-16-12-55-22_25bd8727-8f23-4a90-b2ad-f939a75973ef.jpg?v=1739024092",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/yenidogan-uykusu-icin-bir-annenin-ipuclari",
    title: "Yenidoğan Uykusu İçin Bir Annenin İpuçları",
    cat: "BAKIM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Vera-278_Fotor_fe6b32f6-a131-4c61-a100-502ba8cc9a0a.jpg?v=1739024089",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/petit-mahalle-leyla-kalelioglu-ile-yenikoy",
    title: "Petit Mahalle: Leyla Kalelioğlu İle Yeniköy",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/leylakalelioglu2_52d465a9-ecad-439c-ae32-9d9a90ca4724.jpg?v=1739024093",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/elmali-havuc-corbasi",
    title: "Elmalı Havuç Çorbası",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-10-01-16-22-44_2128ab18-cf62-45f2-85a7-94e0a1e1c686.jpg?v=1739024093",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/saglikli-kahvalti-kasesi",
    title: "Sağlıklı Kahvaltı Kasesi",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-08-06-10-09-07_445f0c1c-356d-43dd-90ff-eb5fc141d4ab.jpg?v=1739024105",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/avokadolu-yaz-salatasi",
    title: "AVOKADOLU YAZ SALATASI",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-09-18-14-42-36_77fb47d0-6c6c-450c-9073-561fd2fdd78d.jpg?v=1739024097",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/buzlu-matcha-latte",
    title: "BUZLU MATCHA LATTE",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-08-18-12-11-44_ee545d0b-f845-4985-8de7-a76a4c537226.jpg?v=1739024102",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/ece-zaim-ve-demir-poyraz",
    title: "Ece Zaim Ve Demir & Poyraz",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20164_012dc7ed-080f-4460-b34a-4339cd9cf1aa.jpg?v=1739024096",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/coddled-yumurta-tarifi",
    title: "CODDLED YUMURTA TARİFİ",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/1dc33264-44dd-4623-a4ac-a6758f33d463_3683fba8-68bd-402b-8e86-6bfab6db8658.jpg?v=1739024097",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/yulafli-kurabiye",
    title: "YULAFLI KURABİYE",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/PHOTO-2018-08-09-21-17-08_1c3f7ddb-c779-49ca-bf64-5450ba354169.jpg?v=1739024106",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/bebeginizi-evdeki-zararlilardan-korumanin-kolay-yollari",
    title: "Bebeğinizi Evdeki Zararlılardan Korumanın Kolay Yolları",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1-3_06e3c09c-453d-4a7b-a286-ef4653d53950.jpg?v=1739024101",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/tanem-sivar-dirvana-ve-suleyman",
    title: "Tanem Sivar Dirvana Ve Süleyman",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_201_66496aa0-8499-4f1c-b928-ee7916369546.jpg?v=1739024101",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/ekran-zamani-krizsiz-sonlandirma",
    title: "Ekran Zamanı: Krizsiz Sonlandırma",
    cat: "EBEVEYNLİK, TEKNOLOJİ, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_3753_Fotor_e6859d70-1d24-44ce-90e1-67db3f4312bd.jpg?v=1739024101",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklara-sorumluluk-bilinci-kazandirma-yollari",
    title: "Çocuklara Sorumluluk Bilinci Kazandırma Yolları",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_2589_ab3f6423-3f60-41e9-953a-07ea73eb91a5.jpg?v=1739024097",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/spor-hayatina-ilk-adim-jimnastik",
    title: "Spor Hayatına İlk Adım: Jimnastik",
    cat: "AKTİVİTE, SPOR, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_1104977210_05fc8864-90e5-433b-ae5d-da392387c328.jpg?v=1739024105",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklarda-dil-gelisimi-hakkinda-her-sey",
    title: "Çocuklarda Dil Gelişimi Hakkında Her Şey",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/timthumb_1f884122-76c1-4e23-afa0-4f8086c4ea72.jpg?v=1739024106",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/ebeveynlik/bebekli-ilk-tatil-icin-oneriler",
    title: "Bebekli İlk Tatil İçin Öneriler",
    cat: "EBEVEYNLİK, SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_198608309_70af416f-7674-4779-b514-c3631fbe9d76.jpg?v=1740732020",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/saglikli-uyku-icin-yatak-rehberi",
    title: "Sağlıklı Uyku için Yatak Rehberi",
    cat: "EV, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_0572_318545f8-e87f-42c6-86f2-20f620133cf3.jpg?v=1739024010",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/is-seyahatine-cikarken",
    title: "İş Seyahatine Çıkarken",
    cat: "ANNE, EBEVEYNLİK, SEYAHAT",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_594617072_ab23f3ec-ec01-416f-a642-5fd594b6e631.jpg?v=1739024110",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklarda-cinsellik-egitimi-neden-onemli",
    title: "Çocuklarda Cinsellik Eğitimi Neden Önemli?",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/xxx_0dec728e-0f78-41e2-a6c6-21f8a34a530c.jpg?v=1739024110",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne-hikayeleri/melis-kaygilaroglu-ve-ada",
    title: "Melis Kaygılaroğlu Ve Ada",
    cat: "ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2_15_d73e5d9b-feda-4fce-8ce2-bc1379c89a67.jpg?v=1739024114",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/ekran-zamani-arastirmalar-ve-sonuclar",
    title: "Ekran Zamanı: Araştırmalar ve Sonuçlar",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_379610650_76d2551e-a4b7-4af7-bdb9-267abed48880.jpg?v=1739024111",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/oyun-oynamanin-dogru-hali",
    title: 'Oyun Oynamanın "Doğru" Hali',
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1849_5ecabb2c-31f6-4160-bdce-6db9ed866ab0.jpg?v=1739024115",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne-hikayeleri/billur-saatci-ve-can",
    title: "Billur Saatçi Ve Can",
    cat: "ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20166_eb0496fb-7815-4325-ba26-e86d62117c41.jpg?v=1739024115",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/pospartum-depresyonu-gercekleri",
    title: "Pospartum Depresyonu Gerçekleri",
    cat: "ANNE, ANNELİK GERÇEKLERİ, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/NilErt_c3_bcrk_20detay_41206fae-ca91-4cc4-8580-bf018e206e54.jpg?v=1739024115",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/evden-zamaninda-cikmak",
    title: "Evden Zamanında Çıkmak",
    cat: "ANNE, EBEVEYNLİK, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/bianca_20balti_20bu_20martin_20parr_8cdfd86a-454d-403f-967b-3354e8602bce.jpg?v=1739024118",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/rachel-araz-kiresepi-bebegini-beklerken",
    title: "Rachel Araz Kiresepi Bebeğini Beklerken",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/1_17_23773cc6-d765-4116-a254-0544ef33472c.jpg?v=1739024119",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/pedagoji-incelemesi-reggio-emilia",
    title: "Pedagoji İncelemesi: Reggio Emilia",
    cat: "EBEVEYNLİK, GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/lastpage_dc54e52e-6aca-455a-93aa-e8fbd176e12a.jpg?v=1739024123",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/oyuncak-temizligi",
    title: "Oyuncak Temizliği",
    cat: "ANNE, SAĞLIK, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_2575_750a1424-5ac8-4f18-bfe9-d2b64ab6ca3f.jpg?v=1739024120",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/mindfullnes-ebeveynler-ve-cocuklar",
    title: "Mindfullnes: Ebeveynler ve Çocuklar",
    cat: "ANNE, EBEVEYNLİK, GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_0597_f17c11b8-304c-4ab2-b49a-24c9535b0a10.jpg?v=1739024119",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/kres-seciminde-dikkat-edilmesi-gerekenler",
    title: "Kreş Seçiminde Dikkat Edilmesi Gerekenler",
    cat: "EBEVEYNLİK, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/diana_20beyaz_8d431dfd-7213-4c6f-9c0c-2c1cd6f3d6e1.jpg?v=1739024124",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocukluktan-itibaren-beslenme-aliskanliklari",
    title: "Çocukluktan İtibaren Beslenme Alışkanlıkları",
    cat: "GELİŞİM, MUTFAK, SAĞLIK, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_9190_33779bb6-afa6-40db-aceb-b8372d0ac1ce.jpg?v=1739024127",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/ekran-zamani-ne-zaman-ne-kadar",
    title: "Ekran Zamanı: Ne Zaman, Ne Kadar?",
    cat: "KÜLTÜR SANAT, TEKNOLOJİ, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/WatchingTelevision_a1364c0e-912f-4b6c-8cd3-0a66ffa8d5a7.jpg?v=1739024128",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/ofke-nobetleriyle-basa-cikmanin-yollari",
    title: "Öfke Nöbetleriyle Başa Çıkmanın Yolları",
    cat: "ANNE, EBEVEYNLİK, GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/C0A8689_fe5feaef-2b42-4674-96f7-49342a6d786d.jpg?v=1739024124",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/bakim/cocuklarda-dis-bakimina-dair-her-sey",
    title: "Çocuklarda Diş Bakımına Dair Her Şey",
    cat: "BAKIM, SAĞLIK, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_339099704_81998aef-21f8-47c8-b3d0-55414eb96534.jpg?v=1739024128",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/bakici-adaylarina-sorulacak-sorularin-tam-listesi",
    title: "Bakıcı Adaylarına Sorulacak Soruların Tam Listesi",
    cat: "ANNE, BAKIM, EBEVEYNLİK, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_4593_1_ade413a5-20a6-4ce3-a41b-ae294fe04668.jpg?v=1739024129",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/babyproof-bebekli-evde-guvenlik-meselesi",
    title: "Babyproof: Bebekli Evde Güvenlik Meselesi",
    cat: "EV, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/cansuyenicioglu_derin-60_cd67ed57-fad9-40f8-9425-abb633499277.jpg?v=1739024132",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/bu-caylari-neden-icmeliyiz",
    title: '"Bu" Çayları neden İçmeliyiz?',
    cat: "MUTFAK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/1_20mag_2011070_Fotor_cff2c884-8d43-4e96-bef4-eaef161d08bb.jpg?v=1739024133",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/dogum-sonrasi-plani-hazirlamak",
    title: "Doğum Sonrası Planı Hazırlamak",
    cat: "ANNE, EBEVEYNLİK, HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_3066_bc94e3fc-7c68-4a12-8bc2-27fecda906c3.jpg?v=1739024133",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/pozitif-disiplin",
    title: "Pozitif Disiplin",
    cat: "ANNE, EBEVEYNLİK, GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_269199455_2caaef6c-13c2-42c7-a510-5ae3f3e13171.jpg?v=1739024136",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/saglikli-sicak-cikolata-tarifleri",
    title: "SAĞLIKLI SICAK ÇİKOLATA TARİFLERİ",
    cat: "MUTFAK, TARİFLER, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1835_4a033761-99ca-4695-8cd0-5a5e37af9325.jpg?v=1739024138",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/yaratici-bir-cocuk-nasil-yetistirilir",
    title: "Yaratıcı Bir Çocuk Nasıl Yetiştirilir?",
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_2904_0d51fa43-ef81-4153-a47d-34fee1724a99.jpg?v=1739024141",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/dikkat-et-demenin-farkli-yollari",
    title: '"Dikkat Et!" Demenin Farklı Yolları',
    cat: "GELİŞİM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_9519_20_2_4b7bc997-0dbe-49c0-8815-0e1d52be7b74.jpg?v=1739024139",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/yenidoganla-ilk-40-gun-hayatta-kalma-kilavuzu",
    title: "Yenidoğanla İlk 40 Gün Hayatta Kalma Kılavuzu",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/image1_20_1_1058cfcd-51b8-4d03-af97-9b51ca352825.jpg?v=1739024137",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/hamilelikte-dogru-beslenme",
    title: "Hamilelikte Doğru Beslenme",
    cat: "ANNE, HAMİLELİK, SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1764_a12e3288-7179-45c9-bbc0-07e17b97867b.jpg?v=1739024142",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/gercekten-iki-dil-bilen-cocuk-yetistirmek",
    title: 'Gerçekten "İki Dil Bilen" Çocuk Yetiştirmek',
    cat: "GELİŞİM, KÜLTÜR SANAT, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/timthumb-4.php_6f017d75-6c9d-46d3-9412-225322b4a54b.jpg?v=1739024142",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/ofiste-kendinize-iyi-bakmanin-5-yolu",
    title: 'Ofiste "Kendinize" İyi Bakmanın 5 Yolu',
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/shutterstock_433518049_8ead756a-911c-490c-88bf-3e20efcb3baa.jpg?v=1739024146",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/gunes-mutlu-mavituncalilar-ve-emir-fey",
    title: "GÜNEŞ MUTLU MAVİTUNCALILAR VE EMİR & FEY",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20187_ffa05edc-bcca-472d-8958-4be8edc59e9c.jpg?v=1739024146",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/lahana-lazanya",
    title: "Lahana Lazanya",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_1782_9bcf9bf5-2304-4bb1-b543-2e2c8cd91112.jpg?v=1739024143",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/aktivite/cocuklar-ile-muzede",
    title: "Çocuklar ile Müzede",
    cat: "AKTİVİTE, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/muze_20kapak_202_5a527968-7a59-4b44-987f-4d8f2ab53e55.jpg?v=1739024147",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/anne-olmak-ve-yeni-normal-kavrami",
    title: 'Anne Olmak ve Yeni "Normal" Kavramı',
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/lalinn_de10fef2-b585-4695-9ee7-5b67a72ce73e.jpg?v=1739024148",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/saglik/ev-yapimi-temizlik-malzemeleri",
    title: "Ev Yapımı Temizlik Malzemeleri",
    cat: "SAĞLIK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/7_20aral_c4_b1k_20petit_20mag6044_42df42f4-8a80-44d7-b6ab-4874b5cf9dc9.jpg?v=1739024151",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/kotu-havalarda-cocuklarla-evde-yapilabilecekler",
    title: "KÖTÜ HAVALARDA ÇOCUKLARLA EVDE YAPILABİLECEKLER",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_0507_Fotor_eb6af4b4-e6b8-4a6e-986c-0553e5661302.jpg?v=1739024151",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/cocuklu-londra-seyahat-rehberi",
    title: "Çocuklu Londra Seyahat Rehberi",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/BEFA4524-8E85-4DD4-A7D9-AD4940210977_Fotor_b304f748-b5f7-427f-8b95-61ea9b43cf11.jpg?v=1739024152",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/okul-nasil-gecti",
    title: "Okul Nasıl Geçti?",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/lalinokul_3e035b9d-d1ff-4356-929f-acd47e74862a.jpg?v=1739024152",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/her-ebeveynin-izlemesi-gereken-5-ted-konusmasi",
    title: "Her Ebeveynin İzlemesi Gereken 5 TED Konuşması",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/JenniferSenior_8f2087ae-d725-4633-9c32-d274644d984b.jpg?v=1739024156",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/elmali-pankek-tarifi",
    title: "Elmalı Pankek Tarifi",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/BAL_20kapak_1_448adc6e-0e82-4e10-8fe7-63cbf64d7e2b.jpg?v=1739024156",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklarla-mutfaga-girmek-icin-bes-neden",
    title: "Çocuklarla Mutfağa Girmek için Beş Neden",
    cat: "MUTFAK, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_9461_4b153094-4062-49f1-829f-9e05dbb30fde.jpg?v=1739024157",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/beste-onal-ve-sim",
    title: "Beste Önal ve Sim",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20185_87a43b4e-edd2-4ca0-9226-fc8c20af506f.jpg?v=1739024157",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuklarla-sonbahar-aktiviteleri",
    title: "Çocuklarla Sonbahar Aktiviteleri",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_9314x_Fotor_65fa7029-6a2e-4a23-ae75-2dce8f190230.jpg?v=1739024160",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/cocuklar-icin-firinda-brokolili-sigara-boregi",
    title: "Çocuklar için Fırında Brokolili Sigara Böreği",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_9287_83682d42-3e5a-4640-bd3a-fc2a86d4fa89.jpg?v=1739024160",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/cocuklarimiza-kendilerini-yabancilardan-korumayi-nasil-ogretebiliriz",
    title:
      "Çocuklarımıza Kendilerini (Yabancılardan) Korumayı Nasıl Öğretebiliriz?",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/DFclAr2XUAEum7I_8e356487-a2a1-4f34-aac7-c2038cb09ba0.jpg?v=1739024161",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/evinizde-waldorf-esintisi",
    title: "Evinizde Waldorf Esintisi",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/leyla_20kapak2_c4d52768-cd75-4918-9557-893a567f13b6.jpg?v=1739024162",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/uc-annenin-iki-yas-sendromu-ile-bas-etme-yontemleri",
    title: "Üç Annenin İki Yaş Sendromu ile Baş Etme Yöntemleri",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/2017-08-10-PHOTO-00002252_0d7296bf-3aa5-42bc-af4f-4b7603813592.jpg?v=1739024166",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/annelik-gercekleri-kaybetmek-hakkinda",
    title: "Annelik Gerçekleri: Kaybetmek Hakkında",
    cat: "ANNE, ANNELİK GERÇEKLERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_0112_7ae80806-da8e-4e0e-a851-9961ada3edab.jpg?v=1739024165",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/bir-kopek-ve-bir-bebek",
    title: "Bir Köpek ve Bir Bebek",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_7101_Fotor_c9dcdb75-5ae7-4682-a213-475a8787fac7.jpg?v=1739024166",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/cocuklarla-izlenecek-en-guzel-10-animasyon",
    title: "Çocuklarla İzlenecek En Güzel 10 Animasyon",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/animasyon_20kapak_9ef049e9-cb15-45f9-a1fb-c5db6e19d4c8.jpg?v=1739024064",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/yasam/cocuklu-hayat-ve-tasinma-meselesi",
    title: "Çocuklu Hayat ve Taşınma Meselesi",
    cat: "YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/MG_2759_20kopya_Fotor_3b9c1a3f-c4e6-442d-a3b7-6efc27b352a7.jpg?v=1739024169",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/bir-annenin-hayat-kolaylastiran-ipuclari",
    title: "Bir Annenin Hayat Kolaylaştıran İpuçları",
    cat: "ANNE, EBEVEYNLİK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_5265_fe1c8d55-495f-473e-a46e-eaab9cd3f74f.jpg?v=1739024170",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/bir-annenin-cocuguyla-ilk-uzun-ucak-yolculugu",
    title: "Bir Annenin Çocuğuyla İlk Uzun Uçak Yolculuğu",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kapak2_2_ba900699-bf98-407b-b195-0043904cf1d3.jpg?v=1739024170",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/elif-karadayi-ve-fatih",
    title: "Elif Karadayı ve Fatih",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kapak_20bateri_432c3543-42f1-4c85-b49d-bb23bb9c4c66.jpg?v=1739024171",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/anne-solhaug-tutar-ile-3-saglikli-icecek-tarifi",
    title: "Anne Solhaug Tutar ile 3 Sağlıklı İçecek Tarifi",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/naturabyanne3_279295c8-a79a-4722-afc4-b3cc0052b3d8.jpg?v=1739024174",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/esen-blake-ile-tek-tencere-puttanesca-makarna",
    title: "ESEN BLAKE İLE TEK TENCERE PUTTANESCA MAKARNA",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/IMG_3334x_3370a5ed-6563-473d-b8d6-af38bcf64ccf.jpg?v=1739024175",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/seyahat/petit-sehir-rehberi-duygu-masson-ve-luna-ile-barselona",
    title: "Petit Şehir Rehberi: Duygu Masson ve Luna ile Barselona",
    cat: "SEYAHAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/MG_2119_20kapak_1_7f5ccaf8-813f-45ac-972b-61669e929952.jpg?v=1739024175",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/4-annenin-tatli-krizi-formulu-sekersiz",
    title: "4 ANNENİN TATLI KRİZİ FORMÜLÜ (ŞEKERSİZ!)",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/kapak_20foto_20renkli_f2e37e99-08f2-4c63-a924-b817ea0583a3.jpg?v=1739024179",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/bebek-dogmadan-yapmaniz-gerekenler",
    title: "Bebek Doğmadan Yapmanız Gerekenler",
    cat: "ANNE, HAMİLELİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/buseucar-cover-2_bf540b89-f545-458b-8b4a-b7d92eee8d67.jpg?v=1739024179",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/cansu-yenicioglu-ve-derin",
    title: "Cansu Yenicioğlu ve Derin",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20173_d21462ea-3172-497d-b80f-4985fd62039d.jpg?v=1739024180",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/esen-hunal-blake-ve-bora-leyla",
    title: "Esen Hünal Blake ve Bora&Leyla",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20175_9e744bd2-1646-4be5-93d9-b7d889a7e229.jpg?v=1739024180",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/anne-arkadaslar-edinmenin-yollari",
    title: "Anne Arkadaşlar Edinmenin Yolları",
    cat: "ANNE, EBEVEYNLİK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/anne_20arkada_c5_9flar_20edinmenin_20yollar_c4_b1_ac5a72a6-01ef-4480-838e-7ec5d9755c5b.jpg?v=1739024184",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/petit-liste-cocuklarla-yolculuk-sirasinda-yanimizda-neler-olmali",
    title: "Petit Liste: Çocuklarla Yolculuk Sırasında Yanımızda Neler Olmalı?",
    cat: "SEYAHAT, YAŞAM, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/no_20212181_822ba0cf-e6b2-4940-a0d2-bafbbfda47d9.jpg?v=1739024184",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/mahizer-aytas-ve-leyla",
    title: "Mahizer Aytaş ve Leyla",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20224_522ea92a-e95d-4a7f-b7d3-72a998f38850.jpg?v=1739024185",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/vegan-bowl-tarifi",
    title: "VEGAN BOWL TARİFİ",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/KAPAK_3f41dfbe-0baa-48b2-b08b-1c9383a3e2be.jpg?v=1740579090",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/pasta-susu-olarak-gingerbread-kurabiye",
    title: "PASTA SÜSÜ OLARAK GINGERBREAD KURABİYE",
    cat: "MUTFAK, PARTİ, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/dandy_2520bakery0377_a5813ebb-5ae7-433f-a606-f809a55a31dc.jpg?v=1739024189",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/cocuk-gelisiminde-rol-oyunlari-neden-onemli",
    title: "Çocuk Gelişiminde Rol Oyunları Neden Önemli?",
    cat: "OYUN, ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/evin_20final_20_1__1_8effba7e-b7ae-4eef-87ae-0028c363695d.jpg?v=1739024189",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/calisan-annelerin-sabah-ipuclari",
    title: "Çalışan Annelerin Sabah İpuçları",
    cat: "ANNE, EBEVEYNLİK, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/annelerin_20haz_c4_b1rlanma_20kapak_d06228f8-e969-41cc-8761-6ffca8f01473.jpg?v=1739024189",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/asli-kalelioglu-ve-mehmet",
    title: "Aslı Kalelioğlu ve Mehmet",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20177_6ca1dc10-adcd-464e-9713-22cb267e983b.jpg?v=1739024190",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/mutfak/balkabakli-tart-tarifi",
    title: "Balkabaklı Tart Tarifi",
    cat: "MUTFAK, TARİFLER",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/foodproject1163M_fb28ae5e-e20e-4a44-8ff9-0685bfe4273f.jpg?v=1739024193",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/anne/claudia-roditi-ve-mila",
    title: "Claudia Roditi ve Mila",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20179_baa11ea8-1c49-4ca2-9afc-0889bef3dcd3.jpg?v=1739024194",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/cocuk/babywearing-hakkinda-bilmeniz-gereken-her-sey",
    title: "Babywearing Hakkında Bilmeniz Gereken Her Şey",
    cat: "ÇOCUK",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/BABYWEAR_20KAPAK_4878be7d-c680-4224-9cd0-e8df2b4d71ac.jpg?v=1739024194",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/kultur-sanat/unutulmaz-televizyon-anneleri-ve-daimi-stilleri",
    title: "Unutulmaz Televizyon Anneleri ve Daimi Stilleri",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/TV-ANNELERI-KAPAK_0a14c56a-a141-4d78-bada-e19ca34a9257.jpg?v=1739024195",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/news/ebeveynlerin-izlemesi-gereken-5-belgesel",
    title: "Ebeveynlerin İzlemesi Gereken 5 Belgesel",
    cat: "KÜLTÜR SANAT, YAŞAM",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/ana_20gorsel_e22d0895-975c-4695-b6a5-5b6f1d8887f1.jpg?v=1739542212",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/news/muge-cubukcu-ve-eren-selim",
    title: "Müge Çubukçu ve Eren&Selim",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20181_2a6a8913-012d-4299-8b95-f670f98b492c.jpg?v=1739542159",
  },
  {
    url: "https://petit-collective.myshopify.com/blogs/news/melodi-inaltong-talvi-ve-olivia",
    title: "Melodi İnaltong Talvi ve Olivia",
    cat: "ANNE, ANNE HİKAYELERİ",
    featured_image:
      "https://cdn.shopify.com/s/files/1/0680/3583/8117/articles/Frame_20183_bd0a2e5e-b5ec-426e-bd63-92d5e1f58ff9.jpg?v=1740577422",
  },
];
